import {
    getInoviceList,
    getListTemplate,
    cancelPayment,
    makePayment,
    creditDistribution,
} from "@/http/customer/customer";

export default {
    namespaced: true,
    state: {
        inoviceList: [],
        templateDataList: [],
    },
    actions: {
        async setInoviceList({ commit }, id) {
            const resp = await getInoviceList(id);
            commit("SET_INOVICE_LIST", resp.data);
            return resp;
        },
        async getListTemplateAction({ commit }, id) {
            const resp = await getListTemplate(id);
            commit("SET_TEMPLATE_DATA_LIST", resp.data);
            return resp;
        },
        async cancelPaymentAction({ commit }, data) {
            const res = await cancelPayment(data.id, data.data);
            return res;
        },
        async makePaymentAction({ commit }, data) {
            const res = await makePayment(data.id, data.data);
            return res;
        },
        async creditDistributionAction({ commit }, data) {
            const res = await creditDistribution(data.id, data.data);
            return res;
        },
    },
    mutations: {
        SET_INOVICE_LIST(state, payload) {
            state.inoviceList = payload;
        },
        SET_TEMPLATE_DATA_LIST(state, payload) {
            state.templateDataList = payload;
        },
    },
    getters: {
        getClientTickets(state) {
            return state.tickets;
        },

    },
};
